import { useBunja } from 'bunja/react';
import { useAtomValue, useSetAtom } from 'jotai';

import { OrderAttributionMapper, orderAttributionAtom } from '@flipster/features/src/shared/order-attribution';
import segment from '@flipster/utils/segment';
import { GNBEvent } from '@flipster/utils/segment/events/gnb';

import { navBunja } from './state';

export function useNav() {
  const { navAtom } = useBunja(navBunja);
  const navigations = useAtomValue(navAtom);

  const setOrderAttribution = useSetAtom(orderAttributionAtom);
  const onClickLink = (name: string, category?: string) => {
    if (category) segment.track(GNBEvent.GnbMenuClick, { name, category });
    else segment.track(GNBEvent.GnbClick, { name });
    if (name === 'Trade' && category === 'Perpetual')
      setOrderAttribution(OrderAttributionMapper.trade.perpetualDefault);
    if (name === 'Trade' && category === 'Spot') setOrderAttribution(OrderAttributionMapper.trade.spotDefault);
  };

  return {
    navigations,
    onClickLink,
  };
}
